import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import config from 'config';
import type { RootState } from 'redux/store';

const baseWorkloadApi = createApi({
  reducerPath: 'workloadApi',
  baseQuery: fetchBaseQuery({
    baseUrl: config.workloadApiUrl,
    prepareHeaders: (headers, { getState }) => {
      const { user } = getState() as RootState;
      if (user) {
        const { accessToken } = user;
        if (accessToken) {
          headers.set('Authorization', `Bearer ${accessToken}`);
        }
      }
      return headers;
    },
  }),
  endpoints: () => ({}),
});

export default baseWorkloadApi;
